var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('UpdateBanner',{attrs:{"show":_vm.showUpdateBanner},on:{"dismiss":function($event){_vm.showUpdateBanner = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }